// src/services/reportService.js
import axios from 'axios';
import { NODE_BACKEND_API_URL } from '../config';

const REPORTS_API_URL = `${NODE_BACKEND_API_URL}/reports`;

class ReportService {
  
  /**
   * Get monthly business report with sales data and weather correlation
   * @param {string} startDate - Format: YYYY-MM-DD
   * @param {string} endDate - Format: YYYY-MM-DD
   * @returns {Promise} API response with report data
   */
  async getMonthlyReport(startDate, endDate) {
    try {
      const response = await axios.get(`${REPORTS_API_URL}/monthly`, {
        params: { startDate, endDate }
        // Note: Auth token is automatically added by axios interceptor in AuthProvider
      });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch monthly report:', error);
      throw error;
    }
  }

  /**
   * Download report data as JSON file
   * @param {Object} report - Report data to download
   * @param {string} filename - Custom filename (optional)
   */
  downloadJSON(report, filename = 'monthly-report.json') {
    const dataStr = JSON.stringify(report, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    
    URL.revokeObjectURL(url);
  }

  /**
   * Format currency in Argentine Peso (ARS)
   * @param {number} amount - Amount to format
   * @returns {string} Formatted currency string
   */
  formatCurrency(amount) {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  /**
   * Format date in Spanish (Argentine format)
   * @param {string} dateString - ISO date string
   * @returns {string} Formatted date
   */
  formatDate(dateString) {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('es-AR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  }
}

export default new ReportService();
